export const USER_DETAILS = 'USER_DETAILS';
export const USER_ACTIVITY = 'USER_ACTIVITY';
export const USER_SLEEP_WEEK = 'USER_SLEEP_WEEK';
export const USER_SLEEP_ACTIVITY = 'USER_SLEEP_ACTIVITY';
